import { render, staticRenderFns } from "./customDashboardConfig.vue?vue&type=template&id=194da45c"
import script from "./customDashboardConfig.vue?vue&type=script&lang=js"
export * from "./customDashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./customDashboardConfig.vue?vue&type=style&index=0&id=194da45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports